import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { FetchErrorResponse } from 'api'
import { useDashboardWidgetData } from '../../../../hooks/useWidgetState'
import ErrorMessage from '../../../share/ErrorMessage'
import ErrorCode from '../../../../enums/ErrorCode'

const ThemeInaccessibleGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData(widgetId)
  const { t } = useTranslation()

  if ((widgetData.error as FetchErrorResponse)?.status === ErrorCode.THEME_INACCESSIBLE_ERROR) {
    return <ErrorMessage>{t('themeNotAccessible')}</ErrorMessage>
  }

  return children
}

export default ThemeInaccessibleGuard
